<template>
    <div>
        <operations-history v-if="viewData.permission_access['perm_view_payments-and-unallocated-documents_payments']"
                :bulkActionUrl="bulk_url"
                :permission_access="viewData.permission_access"
        		table_title="unallocated_payments"
                :operations="viewData.unallocated_payments"
                :multiple_contractors="false"
                :history_icon="true"
                :help-name="'AZA-001'"
                :allow_export="allow_export_operations"
                :return_url="return_url"
                :type="'payments_and_unallocated'"
                @change="refreshViewData">
        </operations-history>

        <documents-history
        		:allow_export="allow_export_documents"
                :bulkActionUrl="bulk_url"
        		table_title="unallocated_documents"
        		:permission_access="viewData.permission_access"
                :documents="viewData.unallocated_documents"
                :multiple_contractors="true"
                :paginate="false"
                :return_url="return_url"
                :hide_balance_in_default_currency_row="true"
                :show_due_date="false"
                :help-name="'AZA-002'"
                @change="refreshViewData">
        </documents-history>

        <div class="row" v-show="dataLoaded">
            <modal-connect-with @save="refreshViewData"></modal-connect-with>

            <div class="ibox mb-0 cont-history" v-if="viewData.permission_access['perm_view_contractor_history_connect_with']">
                <div class="ibox-content">
                    <div class="row">
                        <div class="col-12">
                            <button-show-modal-connect-with @view:refresh="refreshViewData"></button-show-modal-connect-with>
                            <strong>{{ __('selected') }}:</strong>
                            <span id="selected-info">{{ stripeInfo.text }}</span>
                            <span v-show="stripeInfo.tooltip != ''" class="label label-default" data-toggle="tooltip" data-placement="top" :title="stripeInfo.tooltip" data-original-title="">...</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <help-modal/>
    </div>

</template>

<script>
    import updatesAlerts from './../../mixins/updatesAlerts.js';
    import HelpModal from '../../components/help/HelpModal.vue';

    export default {
        mixins: [updatesAlerts],
        components : {HelpModal},
        data() {
            return {
                prevUnallocatedCount: 0,
                viewData: {
                    unallocated_documents: [],
                    unallocated_payments: [],
                    permission_access: [],
                },
                dataLoaded: false,
            }
        },
        methods: {
            refreshViewData: function() {
                this.fetchViewData().then(response => this.$_updatePaymentAndUnallocatedDocumentAlert());
            },
            fetchViewData: function() {
                return this.axios.get('/summaries/payments-and-unallocated-documents/view-data')
                    .then(response => {
                        this.viewData = response.data;
                        this.dataLoaded = true
                    })
                    .catch(error => console.log(error.message))
            },

        },
        computed: {
            stripeInfo: function() {
                let selected = this.$store.getters.getSelected;
                let info = [];
                selected.forEach(item => info.push(item.stripe_info));
                return {
                    text: info.slice(0,3).join(' | '),
                    tooltip: info.slice(3).join(' | '),
                };
            }
        },
        props : [
            'bulk_url',
            'allow_export_operations',
            'allow_export_documents',
            'return_url'
        ],
        mounted: function() {
            this.fetchViewData()
        },
    }
</script>
